import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cf92c504"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "demo-pagination-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
    modelValue: _ctx.pageSize,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.pageSize = $event),
    class: "pageSize_select",
    onChange: _cache[1] || (_cache[1] = $event => _ctx.getList())
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "5/页",
      value: 5
    }), _createVNode(_component_el_option, {
      label: "10/页",
      value: 10
    }), _createVNode(_component_el_option, {
      label: "15/页",
      value: 15
    }), _createVNode(_component_el_option, {
      label: "20/页",
      value: 20
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_pagination, {
    class: "pageno_pagination",
    currentPage: _ctx.pageNo,
    "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => _ctx.pageNo = $event),
    "page-size": _ctx.pageSize,
    layout: "prev, pager, next",
    total: _ctx.totalCount,
    onCurrentChange: _cache[3] || (_cache[3] = $event => _ctx.getList()),
    "hide-on-single-page": true
  }, null, 8, ["currentPage", "page-size", "total"])]);
}